var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"market-segment-form-part"},[_c('MarketSegmentRadioField',_vm._g({attrs:{"choices":_vm.getMarketSegments()}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }